import i18nFactory from '@yandex-int/i18n';

import * as keyset from './NetworkErrors.i18n';

const i18n = i18nFactory(keyset);

const ERROR_LIST = {
    401: i18n('error-401'),
    429: i18n('error-429')
};

export function getNetworkError(code: number): string {
    return ERROR_LIST[code];
}
